import { render, staticRenderFns } from "./Facotrs.vue?vue&type=template&id=d511bab0&"
import script from "./Facotrs.vue?vue&type=script&lang=js&"
export * from "./Facotrs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports